import React from 'react'
import cochez from '../assets/cochez.svg'
import novey from '../assets/novey.svg'
import { useCustomerDisplay } from '../context/CustomerDisplayContext'
import { validatorCompany } from '../utils/validatorCompany'

export default function BackgroundCompanyPage() {
  const { company } = useCustomerDisplay()
  const companySelected = validatorCompany(company)

  const stylesBackgroundCompany = backgroundColor => {
    return {
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor,
      position: 'fixed',
      top: 0,
      left: 0,
    }
  }

  return (
    <div
      data-testid="container-background-company"
      style={
        companySelected === 'CO'
          ? stylesBackgroundCompany('#FFEE00')
          : companySelected === 'NO'
          ? stylesBackgroundCompany('#0055B8')
          : stylesBackgroundCompany('#FFEE00')
      }>
      <img
        data-testid="img-company-logo"
        style={{ width: 500 }}
        src={
          companySelected === 'CO'
            ? cochez
            : companySelected === 'NO'
            ? novey
            : cochez
        }
        alt="Company Logo"
      />
    </div>
  )
}
